import { FormikDialog, FormikTextField, useToast } from '@color/continuum';
import { IErrorPayload, navigateAndRefreshBrowser } from '@color/lib';
import { Formik } from 'formik';
import { generatePath } from 'react-router-dom';

import { useCreateHealthHistoryMutation } from './api';
import { GENERIC_HEALTH_HISTORY_SHOW_PATH } from './paths';
import { CreateHealthHistoryFormikValues } from './types';

interface Props {
  dialogIsOpen: boolean;
  closeDialog: () => void;
}

export const CreateHealthHistoryDialog: React.FC<Props> = (props) => {
  const { dialogIsOpen, closeDialog } = props;
  const { showErrorToast } = useToast();
  const onError = (error: IErrorPayload) => {
    if (error.message) {
      showErrorToast(error.message);
    } else {
      showErrorToast('Something went wrong. Please file a support eng ticket');
    }
  };
  const { mutateAsync: createHealthHistory, isPending: isLoading } = useCreateHealthHistoryMutation(
    {
      onError,
    }
  );

  return (
    <Formik<CreateHealthHistoryFormikValues>
      initialValues={{
        patient_id: '',
      }}
      onSubmit={async (values: CreateHealthHistoryFormikValues) => {
        const response = await createHealthHistory(values);
        navigateAndRefreshBrowser(
          generatePath(GENERIC_HEALTH_HISTORY_SHOW_PATH, {
            id: response.id!,
          })
        );
      }}
    >
      <FormikDialog
        title="Create Health History"
        submitButtonProps={{ isLoading, children: 'Create' }}
        cancelButtonProps={{ children: 'Cancel' }}
        onClose={closeDialog}
        dialogIsOpen={dialogIsOpen}
      >
        <FormikTextField name="patient_id" type="text" label="Patient ID" required />
      </FormikDialog>
    </Formik>
  );
};
